import React, { useState } from 'react'
import { useCurrent } from '../../../hooks';
import FormLangBar from '../../FormLangBar';
import { MwInputText, MwSelector, MwSwitch, MwTextArea } from '../../ui';
import {PRODUCT_TYPE_LIST} from '../../../pages/products/constants'
import { useTranslation } from 'react-i18next';

const BaiscInfo = ({
        productName,
        setProductName,
        productDesc,
        setProductDesc,
        isShowOnWebsite,
        setIsShowOnWebsite,
        isActive,
        setIsActive,
        errors,
        productTypeSelected,
        setProductTypeSelected
    }) => {
    const {currentLangList,currentLangId} = useCurrent();
    const [formLang,setFormLang] = useState(currentLangId);
    const [t]= useTranslation('global');

    return (
      <div className=''>
            <FormLangBar formLang={formLang} setFormLang={setFormLang} currentLangList = {currentLangList}/>
            <div className='flex flex-col '>
                { currentLangList.map((lang) => (
                    <div key={lang.langCode}>
                        <div className={` ${ formLang === lang?.langCode ? 'block' : 'hidden' } `}>
                            <div className=' '>
                            <MwInputText
                                label={`${t("product.productName")} (${lang?.langName})`}
                                id={`productName_${lang?.langCode}`} 
                                placeholder={`${t("product.productName")} (${lang?.langName})`}
                                value={productName[lang?.langCode]}
                                invalid={!!errors[`productName.${lang?.langCode}`] }
                                invalidMsg = {errors[`productName.${lang?.langCode}`]}
                                onChange={(e)=>{
                                    setProductName({...productName, [lang?.langCode]:e.target.value});
                                }}
                            />
                            </div>
                            <div className='my-2'>
                                <MwTextArea
                                    id={`productDesc_${lang?.langCode}`}
                                    label={`${t("product.productDescription")} (${lang?.langName})`}
                                    value={productDesc[lang?.langCode]}
                                    placeholder={`${t("product.productDescription")} (${lang.langName}) `}
                                    rows={2}
                                    onChange={(e) => setProductDesc({...productDesc,[lang?.langCode]:e.target.value})}
                                />
                            </div>
                            <div>
                            <MwSelector
                                label = {t("product.productType")}
                                initalValue = {t("product.selectProductType")}
                                _data = {PRODUCT_TYPE_LIST.filter(item => item.lang === formLang)}
                                dataType = 'labelValue'
                                withAddNew = {false}
                                withSearch = {false}
                                selectedItem = {productTypeSelected}
                                setSelectedItem = {setProductTypeSelected}
                                invalid = {!!errors?.productType}
                                invalidMsg = {errors?.productType}
                            />
                            </div>
                        </div>
                        
                    </div>
                )) }
            </div>
            <div id='OptionsBock' className='flex flex-col justify-between pb-2 px-1'>
                <div className='flex justify-between items-center py-2  border-b mb-2'>
                    <label className='text-xs text-[#251658]'>{t("product.showOnWebsite")}</label>
                    <MwSwitch custKey='isActive' isActive={isShowOnWebsite} setIsActive={setIsShowOnWebsite} onChangeSwitch={()=> setIsShowOnWebsite(!isShowOnWebsite)} />
                </div>
                <div className='flex justify-between items-center py-2  border-b '>
                    <label className='text-xs text-[#251658]'>{t("product.active")}</label>
                    <MwSwitch custKey='isActive' isActive={isActive} setIsActive={setIsActive} onChangeSwitch={() => setIsActive(!isActive)} />
                </div>
            </div>
        </div>
    )
}

export default BaiscInfo
